import { api } from './api'

// One page of chat history for a Global Search chat, always oldest-first. Cursor
// modes (pass at most one): `before` (older than id), `after` (newer than id), or
// `around` (a window centered on id, for jump-to-message). Omit all for the
// latest page. Resolves to { messages, hasMoreBefore, hasMoreAfter }.
export function listMessages(chatId, { limit, before, after, around } = {}) {
  const params = new URLSearchParams()
  if (limit) params.set('limit', String(limit))
  if (before) params.set('before', before)
  if (after) params.set('after', after)
  if (around) params.set('around', around)
  const qs = params.toString()
  return api.get(`/global-search-chats/${chatId}/messages${qs ? `?${qs}` : ''}`)
}

// Search this chat's messages (case-insensitive substring). Resolves to
// { results } where each result is { _id, role, createdAt, snippet }.
export function searchMessages(chatId, q, limit) {
  const params = new URLSearchParams({ q })
  if (limit) params.set('limit', String(limit))
  return api.get(`/global-search-chats/${chatId}/messages/search?${params.toString()}`)
}

// Ask a question in a chat, optionally with a chosen model key and attached guide
// ids. The search runs across the entire library. Resolves to
// { userMessage, assistantMessage }.
export function sendMessage(chatId, text, { model, guides } = {}) {
  return api.post(`/global-search-chats/${chatId}/messages`, { text, model, guides })
}
